// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

export const version = '3.15.0'
export const publishDates = {
	major: '2024-09-13T14:36:29.063Z',
	minor: '2025-07-30T09:07:27.887Z',
	patch: '2025-07-30T09:07:27.887Z',
}
